import React, { useState } from 'react';

function getYouTubeId(url) {
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
}

function UploadForm({ onUpload, onCancel }) {
  const [title, setTitle] = useState('');
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const videoId = getYouTubeId(youtubeUrl);
    if (!videoId) {
      setError('Invalid YouTube URL. Paste the full video URL.');
      return;
    }
    const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    onUpload({ title, url: videoId, thumbnail });
  };

  return (
    <div className="upload-form">
      <h3>Add New Video</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Video Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="YouTube URL (e.g. https://youtube.com/watch?v=...)"
          value={youtubeUrl}
          onChange={(e) => { setYoutubeUrl(e.target.value); setError(''); }}
          required
        />
        {error && <p style={{ color: 'var(--crimson-bright)', fontSize: '0.85rem', marginBottom: '1rem' }}>{error}</p>}
        <div className="form-actions">
          <button type="submit">Add Video</button>
          <button type="button" onClick={onCancel}>Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default UploadForm;
